import React from 'react'
import FAQContainer from '../../faq/containers/FAQContainer'
import UserGuide from './UserGuide'

/**
 * This is the landing page for the help gear
 * 
 * @author Alex Clary
 */
const HelpCenter = ({ serverProperties }) =>
  <div className='lgy-help-center usa-grid'>
    <UserGuide />
    <FAQContainer />
  </div >

export default HelpCenter